import {
  FacebookIcon,
  GoogleAdsIcon,
  InstagramIcon,
  LinkedinIcon,
  StoreIcon,
  OthersIcon,
  TiktokIcon,
  TwitterIcon,
  WebsiteIcon,
  WhatsappIcon,
} from "../../../assets/customSVG/CrmFilterIcons";
import Upload from "../../../assets/customSVG/Upload";
import Flower from "../../../assets/customSVG/Flower";
import Duplicate from "../../../assets/customSVG/Duplicate";
import BroadCastProfile from "../../../assets/customSVG/BroadCastProfile";
import RedCircleInfo from "../../../assets/customSVG/RedCircleInfo";
import { v4 as uuid } from "uuid";
import { ICONS } from "../../../assets/icons";
import Phone from "../../../assets/customSVG/Contact";
import Email from "../../../assets/customSVG/Email";
import { ICONSS } from "assets/icons/index1";
// Sidebar navigation icons for single contact view
import User from "../../../assets/customSVG/User";
import Settings from "../../../assets/customSVG/Settings";
import Flow from "../../../assets/customSVG/sequence/Flow";
import CustomerJourney from "../../../assets/customSVG/CustomerJourney";

const crmFontColor = "#616874";
const primaryColor = "var(--new-primary)";
const headingColor = "#2D3036";

export const CONTACT_TABS = [
  {
    id: 1,
    label: "Profile Attributes",
  }
];

// other defaults
// const contactFilters = [
//   {
//     id: uuid(),
//     label: "WhatsApp",
//     icon: WhatsappIcon,
//     selected: false,
//     access_name: "whatsapp",
//   },
//   {
//     id: 1,
//     label: "Facebook Ads",
//     icon: FacebookIcon,
//     selected: false,
//     access_name: "facebook_ads",
//   },
//   {
//     id: uuid(),
//     label: "Instagram Ads",
//     icon: InstagramIcon,
//     selected: false,
//     access_name: "insta_ads",
//   },
//   {
//     id: uuid(),
//     label: "Linked In Ads",
//     icon: LinkedinIcon,
//     selected: false,
//     access_name: "linkedin_ads",
//   },
//   {
//     id: uuid(),
//     label: "Twitter Ads",
//     icon: TwitterIcon,
//     selected: false,
//     access_name: "x_ads",
//   },
//   {
//     id: uuid(),
//     label: "TikTok Ads",
//     icon: TiktokIcon,
//     selected: false,
//     access_name: "tiktok_ads",
//   },
//   {
//     id: uuid(),
//     label: "Google Ads",
//     icon: GoogleAdsIcon,
//     selected: false,
//     access_name: "google_ads",
//   },
//   {
//     id: uuid(),
//     label: "Website",
//     icon: WebsiteIcon,
//     selected: false,
//     access_name: "website",
//   },
//   {
//     id: uuid(),
//     label: "Store visit",
//     icon: StoreIcon,
//     selected: false,
//     access_name: "store_visit",
//   },
//   {
//     id: uuid(),
//     label: "Others",
//     icon: OthersIcon,
//     selected: false,
//     access_name: "others",
//   },
// ];

const contactFilters = [
  {
    id: 1,
    label: "Other",
    value: "other",
    // icon: ICONS?.OthersIcon,
    icon: OthersIcon,
  },
  {
    id: 2,
    // icon: ICONS?.crmFaceBook,
    label: "Facebook",
    value: "Facebook",
    key: "facebook",
    icon: FacebookIcon,
  },
  // {
  //   id: 3,
  //   // icon: ICONS?.crmFaceBook,
  //   label: "Facebook Reels",
  //   value: "Facebook Reels",
  //   key: "facebook",
  //   icon: FacebookIcon,
  // },
  // {
  //   id: 4,
  //   // icon: ICONS?.crmFaceBook,
  //   label: "Facebook Post",
  //   value: "Facebook Post",
  //   key: "facebook",
  //   icon: FacebookIcon,
  // },

  {
    id: 5,
    // icon: ICONS?.crmInstagram,
    label: "Instagram",
    value: "Instagram",
    key: "instagram",
    //     icon: InstagramIcon,
    icon: InstagramIcon,
  },
  // {
  //   id: 6,
  //   // // icon: ICONS?.crmLinkedIn,
  //   label: "Linked In Ads",
  //   value: "Linked In",
  //   key: "linked_In",
  //   icon: LinkedinIcon,
  // },
  // {
  //   id: 7,
  //   label: "Twitter Ads",
  //   value: "x_ads",
  //   // // icon: ICONS?.crmTwitter,
  //   icon: TwitterIcon,
  // },
  // {
  //   id: 8,
  //   label: "Website",
  //   value: "Website",
  //   key: "website",
  //   icon: WebsiteIcon,
  // },
  // {
  //   id: 9,
  //   // // icon: ICONSS?.website,
  //   label: "Store",
  //   value: "Store",
  //   key: "store",
  //   icon: StoreIcon,
  // },
  {
    id: 10,
    // icon: ICONS?.whatsApp,
    label: "Whatsapp",
    value: "Whatsapp",
    key: "Whatsapp",
    icon: WhatsappIcon,
  },
];

// const contactFilters = [
//   {
//     id: 1,
//     label: "WhatsApp",
//     access_name: "whatsapp",
//   },
//   {
//     id: 2,
//     label: "Facebook Ads",
//     value: "facebook_ads",
//   },
//   {
//     id: 3,
//     label: "Instagram Ads",
//     value: "insta_ads",
//   },
//   {
//     id: 4,
//     label: "Linked In Ads",
//     value: "linkedin_ads",
//   },
//   {
//     id: 5,
//     label: "Twitter Ads",
//     value: "x_ads",
//   },
//   {
//     id: 6,
//     label: "TikTok Ads",
//     value: "tiktok_ads",
//   },
//   {
//     id: 7,
//     label: "Google Ads",
//     value: "google_ads",
//   },
//   {
//     id: 8,
//     label: "Website",
//     value: "website",
//   },
//   {
//     id: 9,
//     label: "Store visit",
//     value: "store_visit",
//   },
//   {
//     id: 10,
//     label: "Others",
//     value: "others",
//   },
// ];

const lifeCycleStages = [
  {
    id: uuid(),
    label: "lead",
    selected: false,
    access_name: "lead",
  },
  {
    id: uuid(),
    label: "contact",
    selected: false,
    access_name: "contact",
  },
  {
    id: uuid(),
    label: "opportunity",
    selected: false,
    access_name: "opportunity",
  },
  {
    id: uuid(),
    label: "won",
    selected: false,
    access_name: "won",
  },
  {
    id: uuid(),
    label: "lost",
    selected: false,
    access_name: "lost",
  },
];

const csvInfo = [
  { id: 1, Icon: BroadCastProfile, label: "Unique contacts" },
  { id: 2, Icon: Duplicate, label: "Duplicate" },
  { id: 3, Icon: RedCircleInfo, label: "Invalid" },
];

const ModelHeadings = {
  csv: {
    sideNavLabel: "Import From File",
    mainLabel: ["Upload a CSV", "Columns with matches"],
    Icon: Upload,
  },
  contact: {
    sideNavLabel: "Single Contact",
    mainLabel: ["Add Contact"],
    Icon: Flower,
  },
};

// const contactsHeader = [
//   'name',
//   'phone',
//   'email',
//   'Contact source',
//   'Life cycle stage',
//   'created date',
//   'location',
//   'tags',
//   'country',
//   'last contacted',
//   'alternative mobile',
//   'first name',
//   'last name',
//   'whatsapp opt out',
//   'email opt out',
//   'SMS opt out',
// ];

const contactsHeaderWithId = [
  {
    label: "name",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "phone_number",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "email",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "contact_source",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "life_cycle_stage",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "created_at",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "provinces",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "tags",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "country",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "last_contacted",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "alternative mobile",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "first name",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "last name",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "whatsapp opt out",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "email opt out",
    id: uuid(),
    default: false,
    selected: true,
  },
  {
    label: "SMS opt out",
    id: uuid(),
    default: false,
    selected: true,
  },
];

export const crmContactHeaders = [
  {
    label: "Name",
    id: 1,
    default: false,
    selected: true,
  },
  {
    label: "Mobile Number",
    id: 2,
    default: false,
    selected: true,
  },
  {
    label: "Email ID",
    id: 3,
    default: false,
    selected: true,
  },
  {
    label: "Contact Origin",
    id: 4,
    default: false,
    selected: true,
  },
  // {
  //   label: "Life Cycle Stage",
  //   id: 5,
  //   default: true,
  //   selected: true,
  // },
  {
    label: "Created Date",
    id: 6,
    default: true,
    selected: true,
  },
  {
    label: "Country",
    id: 7,
    default: true,
    selected: true,
  },
  {
    label: "State",
    id: 8,
    default: true,
    selected: true,
  },
  {
    label: "City",
    id: 9,
    default: true,
    selected: true,
  },
  {
    label: "Tags",
    id: 10,
    default: true,
    selected: true,
  },

  {
    label: "Last Contacted",
    id: 11,
    default: true,
    selected: true,
  },
  {
    label: "Alternative Mobile",
    id: 12,
    default: true,
    selected: true,
  },
  {
    label: "First Name",
    id: 13,
    default: true,
    selected: true,
  },
  {
    label: "Last Name",
    id: 14,
    default: true,
    selected: true,
  },
  {
    label: "Whatsapp Opt In",
    id: 15,
    default: true,
    selected: true,
  },
  // {
  //   label: "Email Opt Out",
  //   id: 16,
  //   default: true,
  //   selected: true,
  // },
  // {
  //   label: "SMS Opt Out",
  //   id: 17,
  //   default: true,
  //   selected: true,
  // },
];

const contactData = [
  {
    id: 1,
    name: {
      name: "john santhosh",
      // url: "https://img.freepik.com/premium-photo/creative-logo-design_113255-32322.jpg",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "whatsapp",
    "Life cycle stage": "whatsapp",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#003285",
      },
      {
        label: "location",
        color: "#FF7F3E",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country:
      "india asdkfas asdasd fa sdfadjkshf askdf asdhfa osidhfaoishdfaisdhf a",
    "last contacted": "Wed May 22 2024",
    // "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "true",
    "email opt out": false,
    "SMS opt out": true,
  },
  {
    id: 2,
    name: {
      name: "agent romanoff",
      url: "https://img.freepik.com/premium-photo/creative-logo-design_113255-33183.jpg",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "instagram",
    "Life cycle stage": "whatsapp",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#79155B",
      },
      {
        label: "location",
        color: "#A63EC5",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "",
    "whatsapp opt out": false,
    "email opt out": true,
    "SMS opt out": "",
  },
  {
    id: 3,
    name: {
      name: "peter Parker",
      url: "https://img.freepik.com/premium-photo/creative-logo-design_113255-29410.jpg",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "store",
    "Life cycle stage": "Lead",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#1f1f",
      },
      {
        label: "location",
        color: "#47d",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india er",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "",
    "email opt out": true,
    "SMS opt out": true,
  },
  {
    id: 4,
    name: {
      name: "Iron man",
      url: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=3087&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "facebook",
    "Life cycle stage": "Opportunities",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#79155B",
      },
      {
        label: "location",
        color: "#A63EC5",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "true",
    "email opt out": "",
    "SMS opt out": "",
  },
  {
    id: 5,
    name: {
      name: "Hulk buster",
      url: "https://img.freepik.com/free-psd/mandala-fractal-design-element-with-flower-pattern-isolated-transparent-background_191095-20655.jpg?w=1060&t=st=1716361760~exp=1716362360~hmac=3a914b8236909bfcc1da1efb7c6bb6b4d3c0147c87e12aec026a4f00d50d72ee",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "googleAds",
    "Life cycle stage": "Won",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#003285",
      },
      {
        label: "location",
        color: "#FF7F3E",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "true",
    "email opt out": "",
    "SMS opt out": "",
  },
  {
    id: 6,
    name: {
      name: "Rob stark",
      url: "https://img.freepik.com/free-vector/ornamental-mandala_24877-54650.jpg?w=1060&t=st=1716361798~exp=1716362398~hmac=4aba994cb279027d6cb50e115d637177bf3c25475849c3c5ee6cc20d49077ae3",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "",
    "Life cycle stage": "",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#1f1f",
      },
      {
        label: "location",
        color: "#47d",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "true",
    "email opt out": "",
    "SMS opt out": "",
  },
  {
    id: 7,
    name: {
      name: "Tyrion lion",
      url: "",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "others",
    "Life cycle stage": "Lost",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#1f1f",
      },
      {
        label: "location",
        color: "#47d",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "true",
    "email opt out": "",
    "SMS opt out": "",
  },
  {
    id: 8,
    name: {
      name: "john",
      url: "https://img.freepik.com/premium-photo/creative-logo-design_113255-29410.jpg",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "others",
    "Life cycle stage": "whatsapp",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#1f1f",
      },
      {
        label: "location",
        color: "#47d",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "true",
    "email opt out": "",
    "SMS opt out": "",
  },
  {
    id: 9,
    name: {
      name: "john",
      url: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8cGVvcGxlfGVufDB8fDB8fHww",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "whatsapp",
    "Life cycle stage": "whatsapp",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#1f1f",
      },
      {
        label: "location",
        color: "#47d",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "true",
    "email opt out": "",
    "SMS opt out": "",
  },
  {
    id: 10,
    name: {
      name: "john",
      url: "https://img.freepik.com/premium-photo/creative-logo-design_113255-29410.jpg",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "whatsapp",
    "Life cycle stage": "whatsapp",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#1f1f",
      },
      {
        label: "location",
        color: "#47d",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "true",
    "email opt out": "",
    "SMS opt out": "",
  },
  {
    id: 11,
    name: {
      name: "john",
      url: "",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "whatsapp",
    "Life cycle stage": "whatsapp",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#1f1f",
      },
      {
        label: "location",
        color: "#47d",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "true",
    "email opt out": "",
    "SMS opt out": "",
  },
  {
    id: 12,
    name: {
      name: "john",
      url: "https://img.freepik.com/free-psd/mandala-fractal-design-element-with-flower-pattern-isolated-transparent-background_191095-20655.jpg?w=1060&t=st=1716361760~exp=1716362360~hmac=3a914b8236909bfcc1da1efb7c6bb6b4d3c0147c87e12aec026a4f00d50d72ee",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "whatsapp",
    "Life cycle stage": "whatsapp",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#1f1f",
      },
      {
        label: "location",
        color: "#47d",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "true",
    "email opt out": "",
    "SMS opt out": "",
  },
  {
    id: 13,
    name: {
      name: "john",
      url: "",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "whatsapp",
    "Life cycle stage": "whatsapp",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#1f1f",
      },
      {
        label: "location",
        color: "#47d",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "true",
    "email opt out": "",
    "SMS opt out": "",
  },
  {
    id: 14,
    name: {
      name: "john",
      url: "",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "whatsapp",
    "Life cycle stage": "whatsapp",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#1f1f",
      },
      {
        label: "location",
        color: "#47d",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "true",
    "email opt out": "",
    "SMS opt out": "",
  },
  {
    id: 15,
    name: {
      name: "john",
      url: "https://img.freepik.com/premium-photo/creative-logo-design_113255-29410.jpg",
    },
    phone: "(+91) 987 654 3210",
    email: "john@aptonworks.com",
    "contact origin": "whatsapp",
    "Life cycle stage": "whatsapp",
    "created date": "Wed May 22 2024",
    location: "chennai, Tamilnadu",
    tags: [
      {
        label: "Travel",
        color: "#1f1f",
      },
      {
        label: "location",
        color: "#47d",
      },
      {
        label: "Lorem",
        color: "#9936",
      },
      {
        label: "Vlog",
        color: "#234",
      },
      {
        label: "ipsum",
        color: "#553",
      },
    ],
    country: "india",
    "last contacted": "Wed May 22 2024",
    "alternative mobile": "+91 9879321124",
    "first name": "john",
    "last name": "santhosh",
    "whatsapp opt out": "true",
    "email opt out": "",
    "SMS opt out": "",
  },
];

const filterKeys = [
  { id: uuid(), name: "name" },
  { id: uuid(), name: "phone" },
  { id: uuid(), name: "email" },
  // { id: uuid(), name: "lead_source" },
  { id: uuid(), name: "created_at" },
  { id: uuid(), name: "tags" },
  { id: uuid(), name: "state" },
  { id: uuid(), name: "city" },
  { id: uuid(), name: "country" },
  { id: uuid(), name: "last_contacted_at" },
  { id: uuid(), name: "alternative_mobile" },
  { id: uuid(), name: "first_name" },
  { id: uuid(), name: "last_name" },
];

const mainFilters = {
  name: {
    props: {
      check: ["empty", "not_empty"],
      type: "text",
      inputType: "text",
    },
    filters: {
      contains: "",
      not_contains: "",
      starts_with: "",
      ends_with: "",
      is_not: "",
      is: "",
      empty: "",
      not_empty: "",
    },
  },
  phone: {
    props: {
      check: ["empty", "not_empty"],
      type: "text",
      inputType: "number",
    },
    filters: {
      contains: "",
      not_contains: "",
      is_not: "",
      is: "",
      // empty: "",
      // not_empty: "",
    },
  },
  email: {
    props: {
      check: ["empty", "not_empty"],
      type: "text",
      inputType: "text",
    },
    filters: {
      contains: "",
      not_contains: "",
      is_not: "",
      is: "",
      // empty: "",
      // not_empty: "",
    },
  },
  lead_source: {
    props: {
      check: ["empty", "not_empty"],
      type: "dropdown",
      data: contactFilters,
    },
    filters: {
      is: "",
      is_not: "",
      empty: "",
      not_empty: "",
    },
  },
  created_at: {
    props: {
      check: [],
      type: "date",
      inputType: "date",
    },
    filters: {
      is: "",
      is_not: "",
      before: "",
      after: "",
    },
  },
  tags: {
    props: {
      check: ["empty", "not_empty"],
      type: "tags",
    },
    filters: {
      is: "",
      is_not: "",
      empty: "",
      not_empty: "",
    },
  },
  state: {
    props: {
      check: ["empty", "not_empty"],
      type: "text",
      inputType: "text",
    },
    filters: {
      contains: "",
      not_contains: "",
      is_not: "",
      is: "",
      empty: "",
      not_empty: "",
    },
  },
  state: {
    props: {
      check: ["empty", "not_empty"],
      type: "text",
      inputType: "text",
    },
    filters: {
      contains: "",
      not_contains: "",
      is_not: "",
      is: "",
      empty: "",
      not_empty: "",
    },
  },
  city: {
    props: {
      check: ["empty", "not_empty"],
      type: "text",
      inputType: "text",
    },
    filters: {
      contains: "",
      not_contains: "",
      is_not: "",
      is: "",
      empty: "",
      not_empty: "",
    },
  },
  country: {
    props: { check: ["empty", "not_empty"], type: "text", inputType: "text" },
    filters: {
      contains: "",
      not_contains: "",
      is_not: "",
      is: "",
      empty: "",
      not_empty: "",
    },
  },
  last_contacted_at: {
    props: {
      check: ["empty", "not_empty"],
      type: "date",
      inputType: "date",
    },
    filters: { is: "", is_not: "", empty: "", not_empty: "" },
  },
  alternative_mobile: {
    props: {
      check: ["empty", "not_empty"],
      type: "text",
      inputType: "number",
    },
    filters: {
      contains: "",
      not_contains: "",
      is_not: "",
      is: "",
      // empty: "",
      // not_empty: "",
    },
  },
  first_name: {
    props: {
      check: ["empty", "not_empty"],
      type: "text",
      inputType: "text",
    },
    filters: {
      contains: "",
      not_contains: "",
      starts_with: "",
      ends_with: "",
      is_not: "",
      is: "",
      empty: "",
      not_empty: "",
    },
  },
  last_name: {
    props: { check: ["empty", "not_empty"], type: "text", inputType: "text" },
    filters: {
      contains: "",
      not_contains: "",
      starts_with: "",
      ends_with: "",
      is_not: "",
      is: "",
      empty: "",
      not_empty: "",
    },
  },
  whatsapp_opt_out: {
    props: {
      check: ["is_true", "is_false"],
      type: "text",
      inputType: "text",
    },
    filters: {
      is_true: "",       // Backend: opted_out->'whatsapp' = 'true'
      is_false: "",      // Backend: opted_out->'whatsapp' = 'false' OR NULL
    },
  },
};

const singleContactFields = {
  "profile information": [
    {
      id: uuid(),
      label: "first_name",
      icon: "",
      editable: true,
      access_name: "first_name",
    },
    {
      id: uuid(),
      label: "last_name",
      icon: "",
      editable: true,
      access_name: "last_name",
    },
    {
      id: uuid(),
      label: "date_of_birth",
      icon: Phone,
      editable: true,
      access_name: "date_of_birth",
    },
    {
      id: uuid(),
      label: "age_range",
      icon: "",
      editable: true,
      access_name: "age_range",
    },
    {
      id: uuid(),
      label: "gender",
      icon: "",
      editable: true,
      access_name: "gender",
    },
    {
      id: uuid(),
      label: "profession_1",
      icon: "",
      editable: true,
      access_name: "profession_1",
    },
    {
      id: uuid(),
      label: "profession_2",
      icon: "",
      editable: true,
      access_name: "profession_2",
    },
    {
      id: uuid(),
      label: "contact_origin",
      icon: "",
      editable: true,
      access_name: "contact_origin",
      type: "dropdown",
      data: [...contactFilters],
    },
    {
      id: uuid(),
      label: "life_cycle_stage",
      icon: "",
      editable: true,
      access_name: "lc_stage",
      type: "dropdown",
      data: [...lifeCycleStages],
    },
    {
      id: uuid(),
      label: "assignee",
      icon: Phone,
      editable: true,
      access_name: "assignee",
    },
    {
      id: uuid(),
      label: "last_contacted",
      icon: "",
      editable: false,
      access_name: "last_contacted_at",
    },
    {
      id: uuid(),
      label: "created_date",
      icon: "",
      editable: false,
      access_name: "created_at",
    },
    {
      id: uuid(),
      label: "location",
      icon: Phone,
      editable: true,
      access_name: "location",
    },
    {
      id: uuid(),
      label: "assignee",
      icon: "",
      editable: true,
      access_name: "",
      type: "dropdown",
      data: [...contactFilters],
    },
  ],
  // "contact information": [

  //   "phone_info": [
  //     {
  //       id: uuid(),
  //       label: "phone_number",
  //       icon: Phone,
  //       editable: true,
  //       access_name: "phone_number",
  //     },
  //     {
  //       id: uuid(),
  //       label: "work_phone",
  //       icon: Phone,
  //       editable: true,
  //       access_name: "work_mobile",
  //     },
  //     {
  //       id: uuid(),
  //       label: "alternative_phone",
  //       icon: Phone,
  //       editable: true,
  //       access_name: "alternative_mobile",
  //     },
  //   ],
  //   "email_info: [
  //     {
  //       id: uuid(),
  //       label: "email",
  //       icon: Email,
  //       editable: true,
  //       access_name: "email",
  //     },
  //     {
  //       id: uuid(),
  //       label: "work_email",
  //       icon: Email,
  //       editable: true,
  //       access_name: "work_email",
  //     },
  //     {
  //       id: uuid(),
  //       label: "secondary_email",
  //       icon: Email,
  //       editable: true,
  //       access_name: "secondary_email",
  //     },
  //   ],
  // ],
  "address info": [
    {
      id: uuid(),
      label: "address_line_1",
      editable: true,
      access_name: "address_line_1",
    },
    {
      id: uuid(),
      label: "address_line_2",
      editable: true,
      access_name: "address_line_2",
    },
    { id: uuid(), label: "country", editable: true, access_name: "country" },
    { id: uuid(), label: "state", editable: true, access_name: "state" },
    { id: uuid(), label: "city", editable: true, access_name: "city" },
    {
      id: uuid(),
      label: "zip/Postal code",
      editable: true,
      access_name: "zip",
    },
  ],
  "secondary address": [
    {
      id: uuid(),
      label: "address_line_1",
      editable: true,
      access_name: "address_line_1",
    },
    {
      id: uuid(),
      label: "address_line_2",
      editable: true,
      access_name: "address_line_2",
    },
    { id: uuid(), label: "country", editable: true, access_name: "country" },
    { id: uuid(), label: "state", editable: true, access_name: "state" },
    { id: uuid(), label: "city", editable: true, access_name: "city" },
    {
      id: uuid(),
      label: "zip/Postal code",
      editable: true,
      access_name: "zip",
    },
  ],
  tags: null,
  "opt out": [
    {
      id: uuid(),
      label: "whatsapp",
      selected: true,
      access_name: "opt_wap",
      date: "2024-06-11T05:43:55.896Z",
    },
    {
      id: uuid(),
      label: "email",
      selected: false,
      access_name: "opt_email",
      date: "2024-06-10T05:43:55.896Z",
    },
    {
      id: uuid(),
      label: "SMS",
      selected: false,
      access_name: "opt_sms",
      date: "2024-06-03T05:43:55.896Z",
    },
  ],
  "social profile": [
    {
      id: uuid(),
      label: "facebook",
      icon: FacebookIcon,
      editable: true,
      access_name: "prof_fb",
    },
    {
      id: uuid(),
      label: "instagram",
      icon: InstagramIcon,
      editable: true,
      access_name: "prof_ig",
    },
    {
      id: uuid(),
      label: "twitter(X)",
      icon: TwitterIcon,
      editable: true,
      access_name: "prof_x",
    },
    {
      id: uuid(),
      label: "linkedIn",
      icon: LinkedinIcon,
      editable: true,
      access_name: "prof_linkedin",
    },
    {
      id: uuid(),
      label: "tikTok",
      icon: TiktokIcon,
      editable: true,
      access_name: "prof_tiktok",
    },
  ],
};

const optedOut = [
  {
    id: 1,
    name: "WhatsApp",
    in: "Opted In",
    out: "Opted Out",
    type: "whatsapp",
    updateField: "whatsapp_last_update",
  },
  // {
  //   id: 2,
  //   name: "Email",
  //   in: "Subscribed",
  //   out: "Unsubscribed",
  //   type: "email",
  //   updateField: "email_last_update",
  // },
  // {
  //   id: 3,
  //   name: "Sms",
  //   in: "Opted In",
  //   out: "Opted Out",
  //   type: "sms",
  //   updateField: "sms_last_update",
  // },
];

export const singleContactFieldss = [
  {
    id: 1,
    title: "Preofile infomtion",
    subtitle: [
      {
        id: 1,
        label: "First name",
      },
      {
        id: 1,
        label: "First name",
      },
      {
        id: 1,
        label: "First name",
      },
    ],
  },
];

const selectedContactData = contactData.map((item, i) => {
  return { id: item.id, selected: false };
});
/**
 * Navigation items for single contact view sidebar
 * Each item includes an icon, label, and selection state
 * Icons are custom SVG components that accept color/size props
 */
const singleContactNav = [
  {
    id: uuid(),
    selected: true,
    label: "overview",
    icon: User // User profile icon for overview section
  },
  {
    id: uuid(),
    selected: false,
    label: "Settings",
    icon: Settings // Settings/gear icon for contact settings
  },
  // { id: uuid(), selected: false, label: "chat history" },
  // { id: uuid(), selected: false, label: "conversation insights" },
  {
    id: uuid(),
    selected: false,
    label: "customer journey",
    icon: CustomerJourney // Green gradient clock/history icon representing customer timeline
  },
  {
    id: uuid(),
    selected: false,
    label: "flow responses",
    icon: Flow // Flow diagram icon representing flow responses section
  },
  // { id: uuid(), selected: false, label: "attachments" },
  // { id: uuid(), selected: false, label: "invoice details" },
  // { id: uuid(), selected: false, label: "tickets" },
];

// NEW: Helper functions for profile attributes filtering

// Generate profile attribute filter keys dynamically
export const getProfileAttributeFilterKeys = (profileAttributes) => {
  if (!profileAttributes || !Array.isArray(profileAttributes)) {
    return [];
  }

  // Get list of static filter names to avoid duplicates
  const staticFilterNames = filterKeys.map(f => f.name);

  // Additional fields to exclude (variations of existing filters)
  const excludedFields = [
    ...staticFilterNames,
    'email_address', 'phone_number', 'mobile_number', 'mobile_phone',
    'telephone', 'contact_email', 'contact_phone'
  ];

  return profileAttributes
    .filter(attr => {
      // Exclude profile attributes that have the same 'name' as static filters
      // This prevents duplicates like "first_name", "email_address", "phone_number", etc.
      const isDuplicate = excludedFields.includes(attr.name);
      return !isDuplicate;
    })
    .map(attr => ({
      id: attr.id,
      name: `attr_${attr.id}`,
      label: attr.label,
      type: attr.attribute_type, // STRING, INTEGER, BOOLEAN, DATE
      isProfileAttribute: true
    }));
};

// Generate filter config based on attribute type
// Maps to backend operators in AudienceSetMembersQuery
export const getProfileAttributeFilterConfig = (attributeType) => {
  switch (attributeType.toUpperCase()) {
    case 'STRING':
      return {
        props: {
          check: ["is_null", "is_not_null"], // Backend: is_null, is_not_null
          type: "text",
          inputType: "text"
        },
        filters: {
          contains: "",       // Backend: LIKE %value%
          starts_with: "",    // Backend: LIKE value%
          ends_with: "",      // Backend: LIKE %value
          is: "",            // Backend: = (equals)
          is_not: "",        // Backend: != (not_equals)
          is_null: "",       // Backend: IS NULL
          is_not_null: ""    // Backend: IS NOT NULL
        }
      };

    case 'INTEGER', 'NUMBER':
      return {
        props: {
          check: [],
          type: "text",
          inputType: "number"
        },
        filters: {
          is: "",            // Backend: = (equal to)
          is_not: "",        // Backend: != (not equal to)
          greater_than: "",            // Backend: > (greater than)
          less_than: "",            // Backend: < (less than)
        }
      };
    case 'FLOAT':
    case 'DECIMAL':
      return {
        props: {
          check: ["is_null", "is_not_null"],
          type: "text",
          inputType: "number"
        },
        filters: {
          is: "",            // Backend: = (equals)
          is_not: "",        // Backend: != (not_equals)
          gt: "",            // Backend: > (greater than)
          gte: "",           // Backend: >= (greater than or equal)
          lt: "",            // Backend: < (less than)
          lte: "",           // Backend: <= (less than or equal)
          is_null: "",       // Backend: IS NULL
          is_not_null: ""    // Backend: IS NOT NULL
        }
      };

    case 'BOOLEAN':
      return {
        props: {
          check: ["is_true", "is_false"],
          type: "text",
          inputType: "text"
        },
        filters: {
          is_true: "",       // Backend: = true
          is_false: ""       // Backend: = false
        }
      };

    case 'DATE':
    case 'DATETIME':
      return {
        props: {
          check: [],
          type: "date",
          inputType: "date"
        },
        filters: {
          is: "",            // Backend: = (equals)
          is_not: "",        // Backend: != (not_equals)
          before: "",        // Backend: lt (<)
          after: ""          // Backend: gt (>)
        }
      };

    default:
      // Fallback for unknown attribute types - treat as STRING
      console.warn('Unknown attribute type:', attributeType, '- treating as STRING');
      return {
        props: {
          check: ["is_null", "is_not_null"],
          type: "text",
          inputType: "text"
        },
        filters: {
          contains: "",       // Backend: LIKE %value%
          starts_with: "",    // Backend: LIKE value%
          ends_with: "",      // Backend: LIKE %value
          is: "",            // Backend: = (equals)
          is_not: "",        // Backend: != (not_equals)
          is_null: "",       // Backend: IS NULL
          is_not_null: ""    // Backend: IS NOT NULL
        }
      };
  }
};

// Combined filter keys (static + profile attributes)
export const getAllFilterKeys = (profileAttributes) => {
  const staticFilters = filterKeys;
  const profileFilters = getProfileAttributeFilterKeys(profileAttributes);

  // getProfileAttributeFilterKeys already filters out duplicates,
  // so we can just combine them directly
  return [...staticFilters, ...profileFilters];
};

// Special fields that should use their field name instead of attr_<id> format
// These match the backend switch case in audience_set_members_query.rb
const SPECIAL_PROFILE_ATTRIBUTE_FIELDS = [
  'date_of_birth',
  'age',
  'gender',
  'tags',
  'birth_year',
  'birth_month',
  'birth_date',
  'whatsapp_opt_out'
];

// Helper function to get the correct field name for a profile attribute
// Returns the actual field name for special attributes, otherwise returns attr_<id>
export const getProfileAttributeFieldName = (filterName, profileAttributes) => {
  // Check if this is a profile attribute (format: attr_<id>)
  if (!filterName || !filterName.startsWith('attr_')) {
    return filterName;
  }

  // Extract attribute ID
  const attrId = parseInt(filterName.replace('attr_', ''));

  // Find the attribute
  const attribute = profileAttributes.find(attr => attr.id === attrId);

  if (!attribute) {
    return filterName; // Fallback to original if not found
  }

  // Check if this attribute's name is a special field
  if (SPECIAL_PROFILE_ATTRIBUTE_FIELDS.includes(attribute.name)) {
    return attribute.name; // Use the actual field name (e.g., 'date_of_birth')
  }

  // For regular profile attributes, use attr_<id> format
  return filterName;
};

// Helper function to convert operator names to user-friendly labels
export const getOperatorLabel = (operator) => {
  const operatorLabels = {
    // String operators
    'contains': 'Contains',
    'starts_with': 'Starts With',
    'ends_with': 'Ends With',

    // Equality operators
    'is': 'Is',
    'is_not': 'Is Not',

    // Numeric/Date comparison operators
    'gt': 'Greater Than',
    'gte': 'Greater Than or Equal',
    'lt': 'Less Than',
    'lte': 'Less Than or Equal',
    'before': 'Before',
    'after': 'After',

    // Boolean operators
    'is_true': 'Is True',
    'is_false': 'Is False',

    // Null checks
    'is_null': 'Is Empty',
    'is_not_null': 'Is Not Empty',
    'empty': 'Is Empty',
    'not_empty': 'Is Not Empty',

    // Array operators
    'in': 'In'
  };

  return operatorLabels[operator] || operator.charAt(0).toUpperCase() + operator.slice(1).replace(/_/g, ' ');
};

export {
  filterKeys,
  mainFilters,
  contactFilters,
  lifeCycleStages,
  crmFontColor,
  primaryColor,
  ModelHeadings,
  headingColor,
  contactData,
  contactsHeaderWithId,
  singleContactNav,
  singleContactFields,
  selectedContactData,
  csvInfo,
  optedOut,
};
